import { render, staticRenderFns } from "./BackToParentPage.vue?vue&type=template&id=093bdb04&"
import script from "./BackToParentPage.vue?vue&type=script&lang=ts&"
export * from "./BackToParentPage.vue?vue&type=script&lang=ts&"
import style0 from "./BackToParentPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonCircle: require('/tmp/build_71ad00c4/src/components/button/Circle.vue').default})
